import React from 'react';
import styled from 'styled-components';

export const FlexRow = styled.div`
  display: flex;
  flex-direction: row;
`

export const TitleView = styled.h1`
  margin-left: 15px;
  font-size: 1.5vw;
`

export const Container = styled.div`
  height: 80vh;
  /* margin: 2em; */
  width: 100%;
`

export const EditCont = styled.div`
  margin-left: 30px;
`